<template>
  <div >
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="974px"
    :before-close="handleClose"
    class="interview-list"
  >
    <div style="height: 50px;">
      <span
          style="margin-bottom: 5px;margin-right:15px;padding: 5px 15px;border-radius: 20px;text-align: center;background: #f1f7fe;color: #0071fe;cursor: pointer;"
          v-for="(item,index) in interState"
          :class="interChance == item ? 'pitch' : ''"
          @click="search(item, index)"
          :key="index">{{item}}</span>
    </div>
    <el-table :data="gridData">
      <el-table-column
          property="interview_status"
          label="面试状态"
          width="110"
      >
        <template #default="{row}" >
          <span v-if="row.interview_status == '已面试'" style="color: #54d988;">{{row.interview_status}}</span>
          <span v-else-if="row.interview_status == '未面试'" style="color: #f48b26">{{row.interview_status}}</span>
          <span v-else-if="row.interview_status == '邀请未接'" style="color: #884e17">{{row.interview_status}}</span>
          <span v-else-if="row.interview_status == '被拒绝'" style="color: #dc2f2f;">不合适</span>
        </template>
      </el-table-column>
      <el-table-column
        property="true_name"
        label="姓名"
        width="110"
      ></el-table-column>
      <el-table-column
        property="tel"
        label="联系方式"
        width="150"
      ></el-table-column>
      <el-table-column property="job_name"
        width="220"
       label="意向岗位"></el-table-column>
      <el-table-column
        property="remarks"
        label="备注"
        width="140"
      ></el-table-column>
      <el-table-column
        width="210"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <!-- @click="negotiationReminderClick(scope.row,scope.$index)" -->
           <el-button
               @click="showOnlineResume(scope.row.user_id)"
              style="background-color: #f47900;border-radius: 5px;border: none;color: #FFFFFF;font-size: 16px;padding: 8px 10px;">查看简历</el-button>
           <el-button
              @click="showRemarksDialog(scope.row)"
              style="background-color: #005bcd;border-radius: 5px;color: #FFFFFF;border: none;font-size: 16px;padding: 8px 10px;">填写备注</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
   <!-- <el-button style="margin-top: 20px;"  @click="gotoHref">{{lan=='ch'?'导出列表':'Export list'}}</el-button> -->
      <pagination
          v-show="interTotal > 0"
          style="margin-top: 10px;text-align: center;"
          :total="interTotal"
          :page.sync="currentPage"
          :limit.sync="numberPage"
          @pagination="getPagination"
          class="interview-page"
      />
  </span>

  </el-dialog>

  <el-dialog
      title="查看简历"
      class="resume-dialog"
      :visible.sync="showResume"
      :destroy-on-close="true"
      width="1000px"
      top="30vh"
  >

    <div style="overflow: hidden;position: relative;">
      <div class="top-line"></div>
      <online-resume ref="resumeInfo" :applicantMess="applicantMess"></online-resume>
    </div>
  </el-dialog>
  <!-- 备注弹窗 -->
  <el-dialog title="添加备注"
     width="500px" class="remarksDialog"
     :visible.sync="remarksDialogVisible">

      <textarea  class="remarks-textarea" v-model.trim="remarksInfo" maxlength="500"
                 placeholder="请输入备注">
      </textarea>
      <div class="remarks-btn-div">
          <div class="remarks-btn" @click="submitRemarks()">提交</div>
      </div>
  </el-dialog>
</div>
</template>
<script>


import {
  subscribeList,
  agreeAppointment,
  cancelAppointment,
} from "@/api/newRequest";
import {
  cancelBroadcastSubscribe,
  excelBroadcastSub,
  sendNegotiateSms,
  findUserInterview,
  addUserInterviewRemarks
} from "@/api/exhibition";
import Cookie from "@/common/cookie";
import { mapGetters } from "vuex";
import onlineResume from "@/pages/user/onlineResume/resumeInfo";
import { findUserDetails } from "@/api/user";
import pagination from "@/components/Pagination/pagination";
export default {
  components:{onlineResume,pagination},
  props: ["dialogVisible", "roomid", "title"],
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  data() {
    return {
      interChance:"全部",
      interIndex:null,
      interTotal:0,
      interState: ["全部","已面试","未面试","邀请未接","不合适"],
      applicantMess: {},
      gridData: [],
      lan:Cookie.get("lang"),
      showResume: false,
      remarksDialogVisible: false,
      appointmentStatus: false,
      remarksUserId:"",
      remarksInfo:"",
      currentPage: 1,
      numberPage: 10,
      gotoLink:""
    };
  },
  methods: {
    search(item,index) {
      this.interChance = item;
      this.interIndex = index;
      // console.log(index);
      this.loadData();
    },
    getPagination(val){
      this.currentPage = val.page;
      this.loadData();
    },
    //提交备注
    submitRemarks(){
      if(this.remarksInfo){
        this.remarksDialogVisible = false;

        let _this = this;
        let params = {roomid: this.roomid, user_id: this.remarksUserId, remarks: this.remarksInfo};

        addUserInterviewRemarks(params).then((result) => {
          if(result.type == 1){
            this.loadData();
          }
        })
      }else{
          this.showErrorTip('请输入备注');
      }
    },
    //显示备注弹窗
    showRemarksDialog(item){
      this.remarksInfo = item.remarks;
      this.remarksUserId = item.user_id;
      this.remarksDialogVisible = true;
    },
    showOnlineResume(user_id){
      let data = {
        token: this.$store.state.user.token,
        user_id: user_id
      };
      findUserDetails(data).then(res => {
        if (res.type == '1') {
          this.applicantMess = res.data[0];
          this.showResume = true;
          this.$refs.resumeInfo.loadData(res.data[0]);
        }
      });
    },
    negotiationReminderClick(item, index){
      console.log(item.user_id)
      sendNegotiateSms({user_id: item.user_id,broadcast_id: item.broadcast_id}).then((res) => {
        if (res.type == 1) {
          if(this.lan == 'ch'){
            this.$message.success(res.text);
          }else{
            this.$message.success(res.text_en);
          }
        } else {
          if(this.lan == 'ch'){
            this.$message.error(res.text);
          }else{
            this.$message.error(res.text_en);
          }
        }
      });
      //
    },
    gotoHref(){
      excelBroadcastSub({broadcast_id: this.roomid}).then(response => {
            const content = response;
            const blob = new Blob([content], {
              type: " application/vnd.ms-excel"
            });

            const fileName = "预约列表.xls";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }).catch(() => {});;
      //window.location.href = this.gotoLink;
    },
    handleClose() {
      this.$emit("handleclose", false);
    },
    loadData() {
      let data = {
        roomid: this.roomid,
        currentPage: this.currentPage,
        numberPage: this.numberPage,
        jobs: 'jobs'
      };
      if(this.interIndex != null) {
        data.record_status = this.interIndex;
      };
      // console.log("传参=" , data);
      //获取直播列表
      findUserInterview(data).then((res) => {
        let resp = res;
        if (resp.type == 1) {
          let list = resp.data;
          list.forEach((item) => {
            let job_name = "";
            if(item.jobList){
              for(var i in item.jobList){
                if(item.jobList[i].jobc_super_name){
                  job_name += item.jobList[i].jobc_super_name + "•" + item.jobList[i].name;
                  if(i != item.jobList.length - 1){
                    job_name += "; ";
                  }
                }
              };
            }
            item.job_name = job_name;
          });
          this.gridData = list;
          // console.log("34534==" , this.gridData);
          this.interTotal = parseInt(res.datacount);
        } else {
          if(this.lan == 'ch'){
            this.$message.error(resp.text);
          }else{
            this.$message.error(resp.text_en);
          }
        }
        this.interIndex = null;
      });

    },
    succformat(d) {
      if (d.is_success == 0) {
        return this.lan == "ch"?"已达成":"Confirmed";
      } else {
        return this.lan == "ch"?"未达成":"Canceled";
      }
    },
    agreeAppointment(obj,index) {
      console.log(obj, "1111111");
      let broadcast_subscribe_id = obj.broadcast_subscribe_id;
      let p = {
        lan:this.lan
      }
      //同意预约
      agreeAppointment(`/subject/${broadcast_subscribe_id}/0`,p).then((res) => {
        if (res.data.status == 200) {
          this.$message.success(res.data.mess);
          this.appointmentStatus = true;
          this.gridData[index].is_success = 0;
        } else this.$message.error(res.data.mess);
      });
      // axios
      //   .put(
      //     "http://192.168.1.203:8080/subject/" +
      //       broadcast_subscribe_id +
      //       "/" +
      //       0
      //   )
      //   .then((res) => {
      //     if (res.data.status == 200) {
      //       this.$message.success(res.data.mess);
      //       this.appointmentStatus = true;
      //     } else this.$message.error(res.data.mess);
      //   });
    },
    //取消预约
    cancelAppointment(obj,index) {
      // let broadcast_subscribe_id = obj.broadcast_subscribe_id;
      let p = {
        lan:this.lan
      }
      cancelBroadcastSubscribe({user_id: this.userInfo.user_id,broadcast_id: obj.broadcast_id}).then(res => {
        if (res.type == 1) {
          if(this.lan == 'ch'){
            this.$message.success(res.text);
          }else{
            this.$message.success(res.text_en);
          }
          this.loadData();
          //this.appointmentStatus = false;
          //this.gridData[index].is_success = 1;
        } else {
          if(this.lan == 'ch'){
            this.$message.success(res.text);
          }else{
            this.$message.success(res.text_en);
          }
        };
      });
      // axios
      //   .put(
      //     "http://192.168.1.203:8080/subject/" +
      //       broadcast_subscribe_id +
      //       "/" +
      //       1
      //   )
      //   .then((res) => {
      //     if (res.data.status == 200) {
      //       this.$message.success(res.data.mess);
      //       this.appointmentStatus = false;
      //     } else this.$message.error(res.data.mess);
      //   });
    },
  },
  mounted() {},

  watch: {
    roomid(o, n) {
      this.loadData();
    },
    dialogVisible:{
      handler(){
        if(this.dialogVisible) {
          this.interChance = "全部";
        }
      }
    },
  },
};
</script>
<style>

.remarksDialog .el-dialog__body{
    padding: 0 20px 12px 20px !important;
}
.remarks-textarea {
    width: 440px;
    height: 150px;
    padding: 10px;
    margin-top: 10px;
    font-size: 14px;
    resize: none;
    background-color: #f7f7f7;
    border-radius: 10px;
    border: solid 1px #d9d9d9;
    color: #4d4d4d;
}
.remarks-btn-div{
    margin-top: 10px;
    overflow: hidden;
}
.remarks-btn{
    width: 150px;
    height: 48px;
    line-height: 48px;
    background-color: #0071ff;
    border-radius: 4px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
}
.interview-list .el-dialog .el-dialog__header {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  border-bottom: 1px solid #CCCCCC;
  margin: 20px 20px  10px;
  padding-top: 20px;
}
.interview-list .el-dialog .el-dialog__body {
  padding-top: 10px;
}
.interview-list .el-dialog .el-dialog__body .has-gutter tr th {
  background: #f6f9ff;
  color: #313131;
}
.interview-list .el-dialog .el-dialog__body tr td {
  padding-left: 10px;
}
.interview-page .el-pagination.is-background .el-pager li:not(.disabled).active {
   background: #0071FF;
}
.interview-page .el-pagination .el-pager li {
  width: 22px !important;
  height: 28px !important;
}
.interview-page .tiaozhuan {
  margin-left: 75px;
}
.pitch{
  background: #0071FF !important;
  color: #FFFFFF !important;
}
</style>
